import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ThemeToggle } from '@/components/ThemeToggle';
import { Loading } from '@/components/Loading';

/**
 * Login status page. There is NO login form — Cloudflare Access (Google IdP)
 * handles auth at the edge before our SPA loads. We reach this page only when
 * /api/me failed: either Access has not authenticated the browser yet (rare —
 * Access usually redirects first) or the session expired. The fix is to reload
 * so Access can run its OAuth redirect; we surface that as a single action.
 *
 * If we DO have an identity, route onward (approved → dashboard, else → pending).
 */
export function Login() {
  const { loading, email, status, role } = useAuth();

  if (loading) return <Loading />;

  if (email) {
    if (status === 'approved' && role) return <Navigate to="/dashboard" replace />;
    return <Navigate to="/pending" replace />;
  }

  return (
    <main className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="brand-mark large">A</div>
          <h1>Armor EdgeAI</h1>
          <p className="login-sub">Admin Dashboard · 管理員後台</p>
        </div>

        <button
          type="button"
          className="signin-btn"
          onClick={() => window.location.reload()}
        >
          以 Cloudflare Access 登入
        </button>

        <p className="login-note">
          本後台由 Cloudflare Access 保護,僅授權帳號可進入。
          <br />
          若頁面未自動導向登入,請點上方按鈕重新整理。
        </p>

        <div className="login-theme">
          <ThemeToggle />
        </div>
      </div>
    </main>
  );
}
